module.exports = __webpack_public_path__ + "vu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vu.svg
// module id = 1141
// module chunks = 0